// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiComponentProvenanceSchema = z.enum(['CODE','DISCOVERY','HYBRID','MANUAL'] as const);

export type AiComponentProvenanceType = `${z.infer<typeof AiComponentProvenanceSchema>}`

export default AiComponentProvenanceSchema;
